/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { debounce } from '../../api/apiUtils';
import VisaBookingListCard from './VisaBookingListCard';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';

const CONFIRMED = 'CONFIRMED';
const CANCELLED = 'CANCELLED';
const PENDING = 'PENDING';

function VisaBookingList({ visaBookings }) {
  const [searchText, setSearchText] = useState('');
  const [transactionsList, setTransactionsList] = useState(visaBookings);
  const [selectedTab, setSelectedTab] = useState(PENDING);

  const filterByStatus = (list, status) =>
    list.filter((b) => b.booking_status?.toUpperCase() === status);

  const [confirmedList, setConfirmedList] = useState([]);
  const [cancelledList, setCancelledList] = useState([]);
  const [pendingList, setPendingList] = useState([]);
  const [shownList, setShownList] = useState(
    visaBookings.filter((b) => b.booking_status?.toUpperCase() === PENDING),
  );

  useEffect(() => {
    setTransactionsList(visaBookings);
    const pending = filterByStatus(visaBookings, PENDING);
    setShownList(pending);
    setSelectedTab(PENDING);
  }, [visaBookings]);

  useEffect(() => {
    const confirmed = transactionsList.filter(
      (b) =>
        b.booking_status?.toUpperCase() === 'CONFIRM' ||
        b.booking_status?.toUpperCase() === 'CONFIRMED',
    );
    const cancelled = filterByStatus(transactionsList, CANCELLED);
    const pending = filterByStatus(transactionsList, PENDING);
    setConfirmedList(confirmed);
    setCancelledList(cancelled);
    setPendingList(pending);
    setShownList(pending);
    setSelectedTab(PENDING);
  }, [transactionsList]);

  const handleTabSelect = (tab) => {
    setSelectedTab(tab);
    if (tab === CONFIRMED) setShownList(confirmedList);
    else if (tab === CANCELLED) setShownList(cancelledList);
    else setShownList(pendingList);
  };

  const setSearchResults = debounce((val) => {
    let data = [...visaBookings];
    if (val !== '') {
      data = data.filter((o) =>
        Object.keys(o).some(
          (k) =>
            o[k] !== null &&
            o[k] !== undefined &&
            o[k].toString().toLowerCase().includes(val.toLowerCase()),
        ),
      );
    }
    setTransactionsList(data);
  }, 500);

  const handleSearch = (event) => {
    const { value } = event.target;
    setSearchText(value);
    setSearchResults(value);
  };
  console.log(shownList);

  return (
    <section className="flight-booking-list-page">
      <div className="train-search-container">
        <div className="mb-2 d-flex justify-content-end">
          <div style={{ width: '300px' }}>
            <AppTextInput
              value={searchText}
              label="search"
              onChange={handleSearch}
            />
          </div>
        </div>
      </div>
      <div className="d-flex gap-2 flight-booking-list-page_transactions-type-container">
        <button
          type="button"
          onClick={() => handleTabSelect(PENDING)}
          className={selectedTab === PENDING ? 'selected-tx-tab' : ''}
        >
          Pending ({pendingList.length})
        </button>
        <button
          type="button"
          onClick={() => handleTabSelect(CONFIRMED)}
          className={selectedTab === CONFIRMED ? 'selected-tx-tab' : ''}
        >
          Confirmed ({confirmedList.length})
        </button>
        <button
          type="button"
          onClick={() => handleTabSelect(CANCELLED)}
          className={selectedTab === CANCELLED ? 'selected-tx-tab' : ''}
        >
          Cancelled ({cancelledList.length})
        </button>
      </div>
      {shownList.length > 0 ? (
        <div className="hotel-bookings-list_container">
          {shownList.map((booking, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <VisaBookingListCard key={index} bookingData={booking} />
          ))}
        </div>
      ) : (
        <div className="p-3 text-center fw-500">
          <span>No Bookings</span>
        </div>
      )}
    </section>
  );
}

VisaBookingList.propTypes = {
  visaBookings: PropTypes.array.isRequired,
};

export default VisaBookingList;
